exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wysihtml5-command-active {\n  background-color: #DDDDDD;\n}\n\n.wysiwyg-font-size-large {\n  font-size: large;\n}\n\n.wysiwyg-font-size-small {\n  font-size: small;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/article/article.component.css
// module id = ../../../../../src/app/article/article.component.css
// module chunks = main